import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class about_template extends vnTemplate {

    protected getTemplateHtml(): string {

        return `
                
                

                <div class="w-content text emp" style="max-width: 80rem;margin-left: 2rem">
                    <h3 class="site-logo content" style="margin-left: 0"></h3>
                    
                    <p >
                    
                    Welcome to Emaki CMS!<br><br>
                    
                    Emaki CMS is a content management system that simplifies the publishing process, so that its users can focus on creating high quality content. <br><br>
                    
                    Emaki is inspired by real-world illustrated hand scrolls from Classic era Japan. This innovative form of combining text and images was used to tell stories in the 10th century, and our version of Emaki CMS was built from the ground up to help creators do the same thing today. <br><br>
                     
                    Used by some of the largest and most-respected digital publishing brands, Emaki helps serve content to millions of users every day. <br><br>
                    
                    Here are some of the brands leaning on Emaki CMS for their publishing operation:
                    </p>
                    
                    <ul class="about-list">
                    <li class="about-item"><a href="https://screenrant.com/" class="full-icon i-SR" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.cbr.com/" class="full-icon i-CB" target="_blank"></a></li>
                    <li class="about-item"><a href="http://collider.com/" class="full-icon i-CL" target="_blank"></a></li>
                    <li class="about-item"><a href="https://movieweb.com/" class="full-icon i-MW" target="_blank"></a></li>
                    <li class="about-item"><a href="https://gamerant.com/" class="full-icon i-GR" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.thegamer.com/" class="full-icon i-TG" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.dualshockers.com/" class="full-icon i-DS" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.makeuseof.com/" class="full-icon i-MUO" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.androidpolice.com/" class="full-icon i-AP" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.xda-developers.com/" class="full-icon i-XDA" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.pocket-lint.com/" class="full-icon i-PL" target="_blank"></a></li>
                    <li class="about-item"><a href="https://pocketnow.com/" class="full-icon i-PN" target="_blank"></a></li>
                    <li class="about-item"><a href="https://simpleflying.com/" class="full-icon i-SF" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.hotcars.com/" class="full-icon i-HC" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.topspeed.com/" class="full-icon i-TPS" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.givemesport.com/" class="full-icon i-GMS" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.footballfancast.com/" class="full-icon i-FFC" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.footballtransfertavern.com/" class="full-icon i-FTT" target="_blank"></a></li>
                    <li class="about-item"><a href="https://thisisfutbol.com/" class="full-icon i-TIF" target="_blank"></a></li>
                    <li class="about-item"><a href="https://footballleagueworld.co.uk/" class="full-icon i-FLW" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.followfollow.com/" class="full-icon i-FF" target="_blank"></a></li>
                    <li class="about-item"><a href="https://videocelts.com//" class="full-icon i-VC" target="_blank"></a></li>
                    <li class="about-item"><a href="https://thecelticblog.com/" class="full-icon i-TCB" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.thesportster.com/" class="full-icon i-TS" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.thethings.com/" class="full-icon i-TH" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.thetravel.com/" class="full-icon i-TV" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.therichest.com/" class="full-icon i-TR" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.babygaga.com/" class="full-icon i-BG" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.moms.com/" class="full-icon i-MM" target="_blank"></a></li>
                    <li class="about-item"><a href="https://www.thetalko.com/" class="full-icon i-TT" target="_blank"></a></li>                       
                </ul>
                
                </div>
                
            `;
    }

    protected getTemplateName(): string {
        return "about-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        let viewModel = {
        };
        return viewModel;
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/about_template.ts